import type { SensorData } from './analysisTabSensorTypes';

export function getSelectedSensorData(
  sensors: SensorData[],
  selectedSensors: string[],
  chartDataSnapshot: SensorData[],
  hasValidChartData: boolean
): SensorData[] {
  const currentData = sensors.filter(sensor => selectedSensors.includes(sensor.channelId));

  if (currentData.length > 0 && currentData.some(s => s.dataPoints && s.dataPoints.length > 0)) {
    return currentData;
  }

  if (chartDataSnapshot.length > 0 && hasValidChartData && selectedSensors.length > 0) {
    return chartDataSnapshot.filter(sensor => selectedSensors.includes(sensor.channelId));
  }

  return currentData;
}

export function buildChartDataKey(
  selectedSensors: string[],
  selectedData: SensorData[],
  selectedTimeRange: string,
  startDate: Date | null,
  endDate: Date | null,
  customScaling: { [unit: string]: { min: number; max: number } } | null
): string {
  const sensorsWithData = selectedData.filter(sensor => sensor.dataPoints && sensor.dataPoints.length > 0);
  const dataHash = sensorsWithData
    .map(sensor => `${sensor.channelId}-${sensor.dataPoints.length}-${sensor.unit}`)
    .join('|');

  const scalingKey = customScaling
    ? Object.entries(customScaling)
        .map(([unit, values]) => `${unit}-${values.min}-${values.max}`)
        .join('|')
    : 'auto';

  return `${selectedSensors.join(',')}-${dataHash}-${selectedTimeRange}-${startDate?.getTime()}-${endDate?.getTime()}-${scalingKey}`;
}

export function getGroupChartUnitContext(selectedData: SensorData[]) {
  const visibleSensorsWithData = selectedData.filter(sensor => sensor.dataPoints && sensor.dataPoints.length > 0);
  const unitsFromSensorsWithData = visibleSensorsWithData.map(sensor => {
    const unit = sensor.unit?.trim() || '';
    return unit === '' ? sensor.sensorName : unit;
  });
  const uniqueUnits = unitsFromSensorsWithData.filter(
    (unit, index) => unitsFromSensorsWithData.indexOf(unit) === index
  );

  return {
    visibleSensorsWithData,
    uniqueUnits,
    hasDataToDisplay: visibleSensorsWithData.length > 0,
  };
}
